import { Component, output } from '@angular/core';

@Component({
  selector: 'app-parent-ai-overlay',
  standalone: true,
  templateUrl: './parent-ai-overlay.component.html',
  styleUrl: './parent-ai-overlay.component.scss',
})
export class ParentAiOverlayComponent {
  dismiss = output<void>();
}
